export const insertList = {
	InsertClientName: '%client_name%',
	InsertInvoiceDueDate: '%payment_due_date%',
	InsertInvoiceAmount: '%payment_amount%',
	InsertCompanyName: '%business_name%',
	InsertCompanyPhone: '%company_phone%',
	InsertCompanyEmail: '%company_email%',
	InsertClientSurname: '%client_surname%',
	InsertClientPhone: '%client_phone%',
	InsertClientAddress: '%client_address%',
	InsertClientEmail: '%client_email%',
	InsertClientNotes: '%client_notes%',
	InsertJobName: '$jobName$',
	InsertJobDate: '%job_date%',
	InsertJobTime: '%job_time%',
	InsertJobLocation: '%job_location%',
	InsertJobNotes: '%job_notes%',
	InsertAppointmentDate: '%appointment_date%',
	InsertAppointmentTime: '%appointment_time%',
	InsertContractLink:
		'<p><span><a href="%contract_link%">Please view and sign your contract online by clicking here</a></span></p>',
	InsertInvoiceLink:
		'<p><span><a href="%invoice_link%">Please click here to view and pay your invoice online</a></span></p>',
	InsertQuoteLink:
		'<p><span><a href="%quote_link%">Please view your quote online by clicking here</a></span></p>',
	InsertQuestionnaireLink:
		'<p><span><a href="%questionnaire_link%">Please view the questionnaire online by clicking here</a></span></p>',
	InsertGalleriesLink:
		'<p><span><a href="%galleries_link%">Please view the galleries online by clicking here</a></span></p>'
};

const businessName = 'Business Name',
	businessPhone = 'Business Phone',
	businessEmail = 'Business Email',
	paymentDueDate = 'Payment due date',
	paymentAmount = 'Payment amount',
	clientName = 'Client name',
	clientSurname = 'Client Surname',
	clientPhone = 'Client Phone',
	clientEmail = 'Client Email',
	clientAddress = 'Client Address',
	clientNotes = 'Client Notes';

export const basicMenu = {
	businessName: insertList.InsertCompanyName,
	businessPhone: insertList.InsertCompanyPhone,
	businessEmail: insertList.InsertCompanyEmail,
	paymentDueDate: insertList.InsertInvoiceDueDate,
	paymentAmount: insertList.InsertInvoiceAmount,
	clientName: insertList.InsertClientName,
	clientSurname: insertList.InsertClientSurname,
	clientPhone: insertList.InsertClientPhone,
	clientEmail: insertList.InsertClientEmail,
	clientAddress: insertList.InsertClientAddress,
	clientNotes: insertList.InsertClientNotes,
	'Lead/Job Name': insertList.InsertJobName,
	'Lead/Job Date': insertList.InsertJobDate,
	'Lead/Job Time': insertList.InsertJobTime,
	'Lead/Job Location': insertList.InsertJobLocation,
	'Lead/Job Notes': insertList.InsertJobNotes,
	'Quote Link': insertList.InsertQuoteLink,
	'Invoice Link': insertList.InsertInvoiceLink,
	'Contract Link': insertList.InsertContractLink,
	'Questionnaire Link': insertList.InsertQuestionnaireLink,
	'Gallery Link': insertList.InsertGalleriesLink
};

export const basicMenuWithoutGallery = {
	businessName: insertList.InsertCompanyName,
	businessPhone: insertList.InsertCompanyPhone,
	businessEmail: insertList.InsertCompanyEmail,
	paymentDueDate: insertList.InsertInvoiceDueDate,
	paymentAmount: insertList.InsertInvoiceAmount,
	clientName: insertList.InsertClientName,
	clientSurname: insertList.InsertClientSurname,
	clientPhone: insertList.InsertClientPhone,
	clientEmail: insertList.InsertClientEmail,
	clientAddress: insertList.InsertClientAddress,
	clientNotes: insertList.InsertClientNotes,
	'Lead/Job Name': insertList.InsertJobName,
	'Lead/Job Date': insertList.InsertJobDate,
	'Lead/Job Time': insertList.InsertJobTime,
	'Lead/Job Location': insertList.InsertJobLocation,
	'Lead/Job Notes': insertList.InsertJobNotes,
	'Quote Link': insertList.InsertQuoteLink,
	'Invoice Link': insertList.InsertInvoiceLink,
	'Contract Link': insertList.InsertContractLink,
	'Questionnaire Link': insertList.InsertQuestionnaireLink
};

export const mailMenu = {
	businessName: insertList.InsertCompanyName,
	businessPhone: insertList.InsertCompanyPhone,
	businessEmail: insertList.InsertCompanyEmail,
	clientName: insertList.InsertClientName,
	clientSurname: insertList.InsertClientSurname,
	clientPhone: insertList.InsertClientPhone,
	clientEmail: insertList.InsertClientEmail,
	clientAddress: insertList.InsertClientAddress,
	clientNotes: insertList.InsertClientNotes,
	'Lead/Job Name': insertList.InsertJobName,
	'Lead/Job Date': insertList.InsertJobDate,
	'Lead/Job Time': insertList.InsertJobTime,
	'Lead/Job Location': insertList.InsertJobLocation,
	'Lead/Job Notes': insertList.InsertJobNotes,
	'Quote Link': insertList.InsertQuoteLink,
	'Invoice Link': insertList.InsertInvoiceLink,
	'Contract Link': insertList.InsertContractLink,
	'Questionnaire Link': insertList.InsertQuestionnaireLink,
	'Gallery Link': insertList.InsertGalleriesLink
};

export const mailMenuWithoutGalleryLink = {
	businessName: insertList.InsertCompanyName,
	businessPhone: insertList.InsertCompanyPhone,
	businessEmail: insertList.InsertCompanyEmail,
	clientName: insertList.InsertClientName,
	clientSurname: insertList.InsertClientSurname,
	clientPhone: insertList.InsertClientPhone,
	clientEmail: insertList.InsertClientEmail,
	clientAddress: insertList.InsertClientAddress,
	clientNotes: insertList.InsertClientNotes,
	'Quote Link': insertList.InsertQuoteLink,
	'Invoice Link': insertList.InsertInvoiceLink,
	'Contract Link': insertList.InsertContractLink,
	'Questionnaire Link': insertList.InsertQuestionnaireLink
};

export const basicMailMenu = {
	businessName: insertList.InsertCompanyName,
	businessPhone: insertList.InsertCompanyPhone,
	businessEmail: insertList.InsertCompanyEmail,
	clientName: insertList.InsertClientName,
	clientSurname: insertList.InsertClientSurname,
	clientPhone: insertList.InsertClientPhone,
	clientEmail: insertList.InsertClientEmail,
	clientAddress: insertList.InsertClientAddress,
	clientNotes: insertList.InsertClientNotes
};

export const basicMailMenuWithLeadJobDetails = {
	businessName: insertList.InsertCompanyName,
	businessPhone: insertList.InsertCompanyPhone,
	businessEmail: insertList.InsertCompanyEmail,
	clientName: insertList.InsertClientName,
	clientSurname: insertList.InsertClientSurname,
	clientPhone: insertList.InsertClientPhone,
	clientEmail: insertList.InsertClientEmail,
	clientAddress: insertList.InsertClientAddress,
	clientNotes: insertList.InsertClientNotes,
	'Lead/Job Name': insertList.InsertJobName,
	'Lead/Job Date': insertList.InsertJobDate,
	'Lead/Job Time': insertList.InsertJobTime,
	'Lead/Job Location': insertList.InsertJobLocation,
	'Lead/Job Notes': insertList.InsertJobNotes
};

/*
Todo need remove calendarReminderMenu
 */

export const calendarReminderMenu = {
	businessName: insertList.InsertCompanyName,
	businessPhone: insertList.InsertCompanyPhone,
	businessEmail: insertList.InsertCompanyEmail,
	clientName: insertList.InsertClientName,
	clientSurname: insertList.InsertClientSurname,
	clientPhone: insertList.InsertClientPhone,
	clientEmail: insertList.InsertClientEmail,
	clientAddress: insertList.InsertClientAddress,
	clientNotes: insertList.InsertClientNotes,
	'Appointment Date': insertList.InsertAppointmentDate,
	'Appointment Time': insertList.InsertAppointmentTime,
	'Quote Link': insertList.InsertQuoteLink,
	'Invoice Link': insertList.InsertInvoiceLink,
	'Contract Link': insertList.InsertContractLink,
	'Questionnaire Link': insertList.InsertQuestionnaireLink,
	'Gallery Link': insertList.InsertGalleriesLink
};

export const variablesLists = {
	basicMenu,
	mailMenu,
	basicMailMenu,
	basicMenuWithoutGallery,
	mailMenuWithoutGalleryLink,
	basicMailMenuWithLeadJobDetails,
	calendarReminderMenu
};



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=kkml25e9zf!./shared/models/variables-to-insert.ts